import i18next from 'i18next';

i18next.addResources('es', 'projectState', {
  stateOfProject: 'Estado del proyecto'
});

i18next.addResources('en', 'projectState', {
  stateOfProject: 'Project Status'
});

i18next.addResources('pt', 'projectState', {
  stateOfProject: 'Estado do projeto'
});
